<template>
  <div class="flex grow-0 flex-wrap">
    <badge-list
      :value="utmParameters"
      badge-class="h-5 max-w-56 truncate text-xxs leading-4 font-semibold uppercase"
      pill-class="h-5"
      :show-num-of-items="2"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import BadgeList from "@/components/ui/BadgeList.vue";

import type { UtmParameter } from "@/models/applications";

const { modelValue = [] } = defineProps<{
  modelValue: UtmParameter[];
}>();

const utmParameters = computed(() =>
  modelValue.map((param) => `${param.type}: ${param.value}`)
);
</script>
